"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObjectEqualShallow = exports.isObject = void 0;
var _isDefined = require("../misc-checks/isDefined");
/**
 * Tests if argument is an object
 *
 * @name isObject
 * @param {argument} Argument to test
 * @returns {boolean} Result of object tests
 */
const isObject = targetObject => {
  return (0, _isDefined.isDefined)(targetObject) && typeof targetObject === "object" && Object.prototype.hasOwnProperty.call(targetObject, "length") === false;
};

/**
 * Tests if two objects are shallow copies of each other
 *
 * @name isObjectEqualShallow
 * @param {object} First object to test
 * @param {object} Second object to test
 * @returns {boolean} Result of comparison
 */
exports.isObject = isObject;
const isObjectEqualShallow = (objA, objB) => {
  return Object.keys(objA).length === Object.keys(objB).length && Object.keys(objA).every(key => {
    return Object.hasOwnProperty.call(objB, key) && objA[key] === objB[key];
  });
};
exports.isObjectEqualShallow = isObjectEqualShallow;